import { FC } from "react";
import { Trans, useTranslation } from "react-i18next";

// Helpers
import showToast from "@/_lib/toast";

// Services and Interfaces
import { UUID } from "@/interfaces/uuid/uuid";
import { useDeleteRecipeMutation } from "@/repositories/recipe";

// Components
import Modal from "@/components/modal/modal";
import { ApiError } from "@/interfaces/api/error";


interface _DeleteRecipeModalProps {
    open: boolean;
    onClose: () => void;
    recipe_id: UUID;
    name: string;
}

const DeleteRecipeModal: FC<_DeleteRecipeModalProps> = ({
    open,
    onClose,
    recipe_id,
    name
}) => {

    const { t } = useTranslation();
    const [deleteRecipe, { isLoading }] = useDeleteRecipeMutation();

    const handleDelete = () => {
        deleteRecipe(recipe_id).unwrap().then(() => {
            showToast({type: 'success', title: t('notifications.recipe.deleted.title'), message: t('notifications.recipe.deleted.message', {name})});
            onClose();
        }).catch((error: ApiError) => {
            showToast({type: 'error', apiError: error.type})
        })
    }

    return (
        <Modal 
            open={open}
            onClose={onClose}
            title={t('modals.deleteRecipe.title')}
            text={<Trans i18nKey="modals.deleteRecipe.text" values={{ name }} />}
            action1={{
                kind: 'danger',
                label: t('components.buttons.delete'),
                loading: isLoading,
                onClick: handleDelete,
            }}
            cancel={{
                label: t('components.buttons.cancel'),
                disabled: isLoading,
                onClick: onClose
            }}
            sx={{'& .MuiPaper-root': {maxWidth: '480px'}}}
            />
    )
}

export default DeleteRecipeModal;